import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Manifesto from "../components/Manifesto";
import Services from "../components/Services";
import BidForm from "../components/BidForm";
import ServiceArea from "../components/ServiceArea";
import MarketplacePreview from "../components/MarketplacePreview";
import Gallery from "../components/Gallery";
import Donations from "../components/Donations";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-[#050505]">
      <Nav />
      <Hero />
      <Manifesto />
      <Services />
      <BidForm />
      <ServiceArea />
      <MarketplacePreview />
      <Gallery />
      <Donations />
      <Footer />
    </div>
  );
}
